import React from 'react';
import { ChannelType, ReviewStepProps } from '../types';
import EditorConvertToHTML from '../EditorConvertToHTML';

const ReviewStep: React.FC<ReviewStepProps> = ({
  formik,
  emailTemplate,
  isEditing,
  waitingReGenerateTemplate,
  isSubjectChanged,
  currentSubject,
  isView,
  channelType,
  setIsEditing,
  handleReGenerateTemplate,
  handleSaveTemplate,
  setIsSubjectChanged,
  onContentChange,
}) => {

  const handleContentChange = (hasChanged: boolean) => {
    onContentChange && onContentChange(hasChanged);
  };
  return (
    <div className="flex-1 w-full min-h-[calc(100vh-228px)] max-h-[calc(100vh-228px)] sm:min-h-[calc(100vh-226px)] sm:max-h-[calc(100vh-226px)] mx-auto shadow-sm mt-2 sm:mt-4 rounded-lg mb-4">
      {emailTemplate !== '' ? (
        <div className="p-2 sm:p-4">
          {!isView && (
            <div className="flex justify-end gap-2 mb-2 sm:mb-4">
              {!isEditing && (
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    handleReGenerateTemplate();
                  }}
                  type="button"
                  className="text-xs sm:text-sm text-white btn bg-blue-500 hover:bg-blue-600 hover:text-white w-full sm:w-auto px-3 py-2"
                >
                  <span className="align-middle">Re-Generate</span>
                </button>
              )}

              {!isEditing && (
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    setIsEditing(!isEditing);
                  }}
                  type="button"
                  className='text-xs sm:text-sm btn bg-blue-500 hover:bg-blue-600 text-white w-full sm:w-auto px-3 py-2'
                >
                  <span className="align-middle">Edit</span>
                </button>
              )}
            </div>
          )}

          {!!isEditing ? (
            <>
              <div className='flex flex-col sm:flex-row sm:items-end pb-2 relative mb-4 gap-2 sm:gap-0'>
                {channelType === ChannelType.Email && (
                  <>
                    <label className="text-sm sm:text-base font-medium min-w-[60px] capitalize">
                      Subject:
                    </label>
                    <div className="flex-1">
                      <input
                        name="subject"
                        className="w-full form-custom border-slate-200 bg-slate-100 disabled:bg-slate-100 disabled:border-slate-300 disabled:text-slate-500 dark:text-zink-100 placeholder:text-slate-400 text-sm sm:text-base px-3 py-2"
                        placeholder="Enter Campaign subject"
                        type="text"
                        onChange={(e) => {
                          formik.handleChange(e);
                          if (e.target.value !== currentSubject) {
                            setIsSubjectChanged(true);
                          } else {
                            setIsSubjectChanged(false);
                          }
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values.subject || ""}
                        onKeyPress={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                  </>
                )}
                <div className="sm:absolute sm:left-[60px] sm:bottom-[-9px]">
                  {formik.touched["subject"] && typeof formik.errors["subject"] === "string" ? (
                    <div className="text-red-500 text-xs">{formik.errors["subject"] as string}</div>
                  ) : null}
                </div>
              </div>
              <div className="h-full w-full">
                <EditorConvertToHTML
                  isSubjectChanged={isSubjectChanged}
                  content={emailTemplate}
                  onSave={handleSaveTemplate}
                  cancelEdit={() => { setIsEditing(false); }}
                  onContentChange={handleContentChange}
                />
              </div>
            </>
          ) : !waitingReGenerateTemplate ? (
            <>
              {channelType === ChannelType.Email && (
                <>
                  <div className='p-2 flex flex-col sm:flex-row sm:items-end gap-1 sm:gap-0'>
                    <label className="min-w-[60px] capitalize font-bold text-sm sm:text-base">
                      Subject:
                    </label>
                    <span className="text-sm sm:text-base">{formik.values.subject || ""}</span>
                  </div>
                </>
              )}
              <div className='overflow-y-auto p-2'>
                <div className="display-content h-[calc(100vh-490px)] sm:h-[calc(100vh-400px)] min-h-[290px] max-h-[calc(100vh-490px)] sm:max-h-[calc(100vh-400px)] text-sm sm:text-base 
                customSpanTag whitespace-pre-line" dangerouslySetInnerHTML={{ __html: emailTemplate }} />
              </div>
            </>
          ) : (
            <div className="flex-1 flex items-center justify-center">
              <div className="flex flex-col items-center gap-2 p-4">
                <svg
                  className="animate-spin h-6 w-6 text-gray-500"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  />
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  />
                </svg>
                <p className="text-gray-500 text-xs sm:text-sm text-center">
                  Re-generating email template, please wait...
                </p>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="flex-1 flex items-center justify-center">
          <div className="flex flex-col items-center gap-2 p-4">
            <svg
              className="animate-spin h-6 w-6 text-gray-500"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
            <p className="text-gray-500 text-xs sm:text-sm text-center">
              Generating email template, please wait...
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReviewStep;
